import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../config/api';

const useUnreadMessages = (user) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadBreakdown, setUnreadBreakdown] = useState({});

  const checkUnread = useCallback(async () => {
    if (!user?.id) {
      setUnreadCount(0);
      setUnreadBreakdown({});
      return;
    }

    try {
      const data = await apiFetch('/messages/unread/count');
      setUnreadCount(data.count || 0);
      setUnreadBreakdown(data.breakdown || {});
    } catch (err) {
      console.error('Check unread error:', err);
      setUnreadCount(0);
      setUnreadBreakdown({});
    }
  }, [user?.id]);

  const markRead = useCallback((convId) => {
    setTimeout(checkUnread, 100);
  }, [checkUnread]);

  const markAllRead = useCallback(() => {
    setUnreadCount(0);
    setUnreadBreakdown({});
  }, []);

  useEffect(() => {
    checkUnread();
    const interval = setInterval(checkUnread, 3000);
    return () => clearInterval(interval);
  }, [checkUnread]);

  return { unreadCount, unreadBreakdown, markRead, markAllRead };
};

export default useUnreadMessages;
